import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListReferenceValues from './ListReferenceValues'
import ShowReferenceValuePage from './ShowReferenceValuePage'
import NewReferenceValuePage from './NewReferenceValuePage'
import EditReferenceValuePage from './EditReferenceValuePage'

const ReferenceValues = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListReferenceValues} />
    <Route exact path={match.url + '/new'} component={NewReferenceValuePage} />
    <Route path={match.url + '/:id/edit'} component={EditReferenceValuePage} />
    <Route path={match.url + '/:id'} component={ShowReferenceValuePage} />
  </Switch>
)

export default ReferenceValues



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ReferenceValues.jsx